import React from "react";
import { PDFExport } from "@progress/kendo-react-pdf";
import PropTypes from "prop-types";
import bg from "../../assets/images/HeaderDocument.jpg";
import sign_inno from "../../assets/images/sign_inno.png";
import sign_law from "../../assets/images/sign_law.png";
import "./base.css";

const Warning_Corruption = ({
  pdfExportComponent,
  data,
  company,
  company2,
}) => {
  return (
    <>
      <div id="document-box" className="documents">
        <PDFExport
          ref={pdfExportComponent}
          fileName={`หนังสือแจ้งเตือนป้องปราบการทุจริตของพนักงาน - ${data.personal_info_name}`}
          forcePageBreak=".page-break"
        >
          <div id="page1" style={{ fontFamily: "THSarabun" }}>
            <div>
              <img
                id="background"
                src={bg}
                alt="bg"
                style={{
                  width: "800px",
                  height: "auto",
                  position: "absolute",
                  top: "0%",
                  right: "0%",
                  zIndex: -5,
                  boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                }}
              />
            </div>
            <div
              id="content"
              style={{
                zIndex: 2,
              }}
            >
              <div
                id="header"
                className="text-with-bold"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  //26px
                  top: "143px",
                  right: "47px",
                  fontSize: "21.3px",
                  width: "705px",
                  // fontFamily: "angsaBold",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                <b className="docs-font-bold">
                  หนังสือแจ้งเตือนป้องปรามการทุจริตของพนักงาน
                </b>
              </div>

              <div
                className="docs-font"
                id="date"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "187px",
                  right: "74px",
                  fontSize: "19px",
                  // fontFamily: "angsaLight",
                  width: "247px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  // lineHeight: "27px"
                  // backgroundColor: "red"
                }}
              >
                วันที่...........เดือน..............................พ.ศ..............
              </div>
              <div
                id="paragraph1"
                className="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "226px",
                  right: "47px",
                  fontSize: "19px",
                  // fontFamily: "angsaLight",
                  width: "705px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  lineHeight: "26px",
                }}
              >
                &emsp;&emsp;&emsp;เพื่อเป็นการปฎิบัติงานด้วยความโปร่งใส
                ควบคุมการทุจริต และการป้องปรามการทุจริตจากการปฎิบัติงาน
                โดยมิชอบของพนักงาน หากมีเหตุการณ์ทุจริต เช่น
              </div>

              <div
                id="paragraph2"
                className="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "291px",
                  right: "47px",
                  fontSize: "19px",
                  // fontFamily: "angsaLight",
                  width: "705px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  lineHeight: "26px",
                }}
              >
                &emsp;&emsp;&emsp;1. การลักทรัพย์ สินค้า หรือทรัพย์สินอื่นๆ
                หน้าร้าน
                <br />
                &emsp;&emsp;&emsp;2. การยักยอกทรัพย์ เงินสดในลิ้นชัก
                หรือในระหว่างนำฝาก
                <br />
                &emsp;&emsp;&emsp;3. การปรับเปลี่ยน การแก้ไขข้อมูล
                การปลอมแปลงเอกสาร โดยไม่ได้รับอนุมัติจากผู้บังคับบัญชา
                <br />
                &emsp;&emsp;&emsp;4. การแจ้งข้อมูลสินค้าเป็นเท็จ การปกปิด
                บิดเบือน
                <br />
                &emsp;&emsp;&emsp;5. การโยกย้ายถ่ายเท เพื่อปิดบัง Stock สูญหาย
                เพื่อเป็นช่องทางทุจริต หรือ เหตุการณ์อื่นใดที่ส่อในทางทุจริต
                <br />
              </div>

              <div
                id="paragraph3"
                className="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "430px",
                  right: "47px",
                  fontSize: "19px",
                  // fontFamily: "angsaLight",
                  width: "705px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  lineHeight: "26px",
                }}
              >
                &emsp;&emsp;&emsp;
                <u>
                  <b className="docs-font-bold">
                    พนักงานจะได้รับผลของการกระทำดังนี้
                  </b>
                </u>
                &nbsp;หากพนักงานกระทำผิดดังกล่าว หรือมีส่วนรู้เห็น
                และปกปิดไม่แจ้งต้นสังกัดทราบ <br />
                &emsp;&emsp;&emsp;1.&emsp;
                <u className="docs-font-bold">
                  พนักงานจะถูกดำเนินคดีอาญา และฟ้องแพ่งเรียกค่าเสียหาย
                </u>{" "}
                ทั้งต้องหาเงินประกันตัว หากประกันไม่ได้จะต้องถูกจับกุม
                &emsp;&emsp;&emsp;และอาจจะต้องส่งศาล เพื่อขออำนาจศาลฝากขัง
                <br />
                &emsp;&emsp;&emsp;2.&emsp;พนักงานจะมีประวัติอาชญากรติดตัวไปตลอดชีวิต
                ซึ่งอาจจะมีผลกระทบต่อการดำรงชีวิตในภายภาคหน้า การยอมรับจาก
                &emsp;&emsp;&emsp;สังคม เพื่อนร่วมงาน และครอบครัว
                <br />
                &emsp;&emsp;&emsp;
                <u>
                  <b className="docs-font-bold">
                    บริษัทฯจะดำเนินการกับพนักงานทุจริต ดังนี้
                  </b>
                </u>
              </div>
              <div
                id="paragraph3"
                className="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "600px",
                  right: "47px",
                  fontSize: "19px",
                  // fontFamily: "angsaLight",
                  width: "705px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  lineHeight: "26px",
                }}
              >
                &emsp;&emsp;&emsp;&emsp;&nbsp;&nbsp;บริษัทฯ
                จะดำเนินคดีในข้อหาทุจริต และใน
                <u className="docs-font">
                  ข้อหาลักทรัพย์นายจ้าง ซึ่งเป็นความผิดอันยอมความไม่ได้
                </u>
                และมีโทษจำคุกสูงสุด &emsp;&emsp;&emsp;
                <u className="docs-font">
                  ถึงแม้พนักงานจะมาชดใช้ความเสียหายให้กับบริษัทฯ แล้วก็ตาม
                </u>{" "}
                บริษัทฯจะไม่ประนีประนอมยอมความ และจะดำเนินคดีถึงที่สุด
                <br />
                <br />
                <br />
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;..................................................................
                <br />
                &nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                <span className="docs-font" style={{ marginLeft: "12px" }}>
                  นายคงศักดิ์ บรรณาสถิตย์กุล
                </span>
                <br />
                &nbsp;&nbsp;&nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;บริษัท
                {company.name_th}
                <br />
                <br />
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;...................................................................
                <br />
                &nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                <span className="docs-font" style={{ marginLeft: "12px" }}>
                  นายอภินันทกานต์ พงศ์สถาบดี
                </span>
                <br />
                &nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;ฝ่ายกฏหมาย
                <br />
                <br />
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;..................................................................
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;(
                ................................................................
                )
                <br />
                &nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                <span className="docs-font" style={{ marginLeft: "10px" }}>
                  พนักงานรับทราบ
                </span>
                <br />
              </div>
            </div>
            <div id="var" className="var">
              {company2.head && (
                <img
                  src={company2.head}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "100px",
                    right: "10px",
                    top: "20px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              {company2.foot && (
                <img
                  src={company2.foot}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "70px",
                    right: "10px",
                    top: "1060px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              <img
                id="sign_inno"
                src={sign_inno}
                alt="sign_inno"
                style={{
                  height: "100px",
                  width: "178px",
                  position: "absolute",
                  top: "642px",
                  right: "257px",
                  zIndex: -5,
                }}
              />
              <img
                id="sign_law"
                src={sign_law}
                alt="sign_law"
                style={{
                  height: "50px",
                  width: "160px",
                  position: "absolute",
                  top: "777px",
                  right: "285px",
                  zIndex: -5,
                }}
              />
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "183px",
                  right: "262px",
                  fontSize: "20px",
                  width: "35px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.date_day}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "183px",
                  right: "139px",
                  fontSize: "20px",
                  width: "97px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.date_month}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "183px",
                  right: "74px",
                  fontSize: "20px",
                  width: "45px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.date_year}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "935px",
                  right: "274px",
                  fontSize: "20px",
                  width: "202px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_name}
              </div>
            </div>
          </div>
        </PDFExport>
      </div>
    </>
  );
};

Warning_Corruption.propTypes = {
  data: PropTypes.object.isRequired,
  pdfExportComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.object }),
  ]),
};

export default Warning_Corruption;
